<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
    <ion-title>
      PSI Recycling
    </ion-title>
    <img alt="PSI logo" slot="end" class="titleicon" [src]="assets + '/psi_logo.svg'" width="80px" routerLink="/home" />
  </ion-toolbar>
</ion-header>

<ion-content>
    <iframe  class="map" src="https://umap.osm.ch/de/map/standorte-recyclingsammelstellen_8617#17/47.53822/8.22812" frameborder="0"></iframe>
  
</ion-content>